import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchDataSetMemberFieldSchema = withDefaults({
  // No 'search-' prefix -- see search-index-definition.schema.ts's identical comment. Matches
  // Api::V2::Admin::DataSetMemberFieldResource's own bare wire type ('data-set-member-fields',
  // normalized singular).
  type: 'data-set-member-field',
  fields: [
    {
      kind: 'attribute',
      name: 'outputField',
    },
    {
      kind: 'attribute',
      name: 'osType',
    },
    {
      kind: 'attribute',
      name: 'filterable',
    },
    {
      kind: 'attribute',
      name: 'searchable',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'dataSetMember',
      type: 'data-set-member',
      options: {
        async: false,
        inverse: 'dataSetMemberFields',
      },
    },
    {
      kind: 'belongsTo',
      name: 'sourceDataPoint',
      type: 'data-point',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default SearchDataSetMemberFieldSchema;
